import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
  h1 {
    color: ${({ theme }) => theme.colors.secondary};
    font-size: 1.5rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
  button{
    padding: 0;
    svg{
      fill: ${({ theme }) => theme.colors.secondary};
    }
  }
`;